import { PublicCatalogService } from '../../../catalog-services/public-catalog-service';
export class PublicVideoCards extends PublicCatalogService {
    /**
     * Get list of video cards for given video in channel
     * @param channelId
     * @param videoId
     * @param requestConfig
     */
    getList(channelId, videoId, requestConfig) {
        return this.get(`/public/lists/${channelId}/items/${videoId}/actions`, requestConfig);
    }
}
//# sourceMappingURL=video-cards.js.map